import * as yup from 'yup';

export const registerSchema = yup
  .object({
    nome: yup
      .string()
      .required(`register.validations.name.required`)
      .max(200, `register.validations.name.max`),
    email: yup
      .string()
      .email(`register.validations.email.valid`)
      .required(`register.validations.email.required`)
      .max(200, `register.validations.email.max`),
    empresa: yup.string().max(400, `register.validations.company.max`),
    telefone: yup
      .string()
      .required(`register.validations.phone.required`)
      .max(200, `register.validations.phone.max`),
    'tipo-de-usuario': yup.string().required(`register.validations.typeUser.required`),
  })
  .required();

export const registerDefaultValues = {
  nome: ``,
  email: ``,
  empresa: ``,
  telefone: ``,
  'tipo-de-usuario': ``,
};
